import React from "react";

const NoOfferPage = () => {
  console.log("ConfirmationPage");
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white relative">
      <div className="absolute top-12">
        <img src="/assets/img/Footer logo.png" alt="DigitMoney" className="w-36" />
      </div>

      <div className="flex flex-col items-center text-center mt-24">
       <p className="mt-4 text-gray-600 text-lg px-4 m-5">
          Thank you for your interest. At the moment, you are not eligible for a personal loan, but we encourage you to check back in the future.
        </p>
      </div>
    </div>
  );
};

export default NoOfferPage;